    import React, { useEffect, useState } from 'react'
    import { Btn } from "../../../AbstractElements";
    import MultiSelectDropdown from '../../../Component/BasicComponents/Dropdowns/MultiSelectDropdown';
    import { useAddNotificationConfiguration, useGetGradeList, useGetPositionList, useGetRolesList, useGetSingleNotifiation, useUpdateNotification } from '../NotificationRepo';
    import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
    import { useGetOrgUnitsData } from '../../Configuration/Grade Master/hooks/useGradeMaster';
    import CustomInput from '../../../Component/BasicComponents/CustomInput';
    import PaginatedRouteDropdown from '../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper';
    import { getALlRolesList, getPositionList } from '../UseNotification'; 
    import { useGetConfigStatus } from '../../expense/expenseGeoDistance/hook/GeoDistanceRepo';
    
    interface FormData {
        Frequency:null | number | string;
        NotificationDate:string  
        orgUnit:null |number
        NotificationType: string;
        IsEnabled: any ;
        NotificationTime: string;
        NotificationSubject: string;
        NotificationMessage: string;
        RedirectScreen: string;
        Role: number[];
      }

    interface NotificationConfigModalContentProps {
        handleClose: () => void;
        chechStatusSubmitAndUpdate:string;
        selectNotification:any
      }

    const NotificationConfigModalContent : React.FC<NotificationConfigModalContentProps> = ({ selectNotification,handleClose,chechStatusSubmitAndUpdate}) =>{
      

       
        const [selectedNames, setSelectedNames] = useState<{id:number; name:string}[]>([]);
        const [selectPosition,setSelectPosition] = useState<{id:string; label:string}[]>([]);
        const [selectPositionEdit,setselectPositionEdit] = useState<{id:string; label:string}[]>([]);
        const [today,setToday] = useState('');

         const [formData,setformData] = useState<FormData>({
                 Frequency:null,
                 NotificationDate:'',
                 orgUnit:null, 
                 NotificationType:'',
                 IsEnabled: null,
                 NotificationTime:'',
                 NotificationSubject:'',
                 NotificationMessage:'',
                 RedirectScreen:'',
                 Role: []
         })
         
         const Configuration_ID = selectNotification?.id;
         // API
        const{mutate:addNotification} = useAddNotificationConfiguration();
        const {mutate:updateNotification} = useUpdateNotification()
        const {data:apiData, isLoading:apiIsLoading, isSuccess:apiISucess } = useGetSingleNotifiation({ enable: !!Configuration_ID, id: Configuration_ID});
        const { data: orgUnitsData,isLoading:OrgdataIsLoading,isSuccess:OrgIsSuccss} = useGetOrgUnitsData({ enable: true });
        const {data:gradeListData,isLoading:gradeListDataLoading,isSuccess:gradeListDataIsSuccess} =useGetGradeList({enable:true}) 
        const {data:PositionData,isLoading:PositionDataIsloading,isSuccess:PositionDataIsSuccess} = useGetPositionList({enable:true,params:{
          page:1,
          limit:10,
          search:''
        }})
    
        const{data:RolesData,isLoading:RolesIsLoading,isSuccess:rolesIssuccess} = useGetRolesList({enable:true,params:{
            start:1,
            length:30,
            search:'',
        }});     

       const {data:FrequencyData,isLoading:FrequencyLoading,isSuccess:FrequencySuccess} =useGetConfigStatus({enable:true})
       
       useEffect(()=>{
        const now = new Date();
        const formattedDate = now.toISOString().split('T')[0];
        setToday(formattedDate);  
       },[]);

        useEffect(() => {

            if (Configuration_ID && !apiIsLoading && apiISucess && apiData) {
              const item = Array.isArray(apiData) ? apiData[0] : apiData;
              setformData((prev: any) => ({
                ...prev,
                Frequency:item?.data?.Frequency,
                orgUnit:item?.data.Orgunitid,
                NotificationDate:item?.data?.NotificationDate,
                NotificationType: item?.data?.NotificationType,
                IsEnabled: item?.data?.IsEnabled === true ? 1 : 0,
                NotificationTime: item?.data?.NotificationTime,
                NotificationSubject: item?.data?.NotificationSubject,
                NotificationMessage: item?.data?.NotificationMessage,
                RedirectScreen: item?.data?.RedirectScreen
            
              }));  
              // Set selected Grade

            if (Configuration_ID && !apiIsLoading && apiISucess && apiData) {
                const GradeMasterArray = item?.data?.GradeMasterArray 
               
                const mappedGrades = Array.isArray(GradeMasterArray) ?GradeMasterArray.map((item: any) => {
                  return {
                    // id:item?.Gradeid || '-',
                    // name:item?.GradeName || '-'

                       id:item?.Gradeid ?? '-',
                       name:item?.GradeName ?? '-'

                  };
                }): [];

                setSelectedNames(mappedGrades); // ✅ this correctly sets the state
              }
            
              // Position
            if(Configuration_ID && !apiIsLoading && apiISucess && apiData){
               const PositionArray = item?.data?.PositionsArray;
              
               const mappedPosition = Array.isArray(PositionArray) ? PositionArray.map((item:any)=>{
                return {
                  // id:String(item?.PositionId ||'-'),
                  // label: String(item?.PositionName ||'-'),

                id: String(item?.PositionId ?? '-'),
                label: String(item?.PositionName ?? '-'),
                }
               }):[]
               
               setselectPositionEdit(mappedPosition)
             }  
            
            }
            
          }, [Configuration_ID,apiData]);
          
              const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
               ([key, value]) => ({
                  id: Number(key),
                  label: String(value),
               })
              );
          
        const handleSubmit = (e: React.FormEvent) => {
            e.preventDefault();

            if(chechStatusSubmitAndUpdate === 'Submit'){
                const RolesArray = selectedNames.map((item:any)=>(item.id)); 
                const PositionsArray = Array.from(new Set(selectPosition.map((item) => item.id))).map(Number);
                const ReqBody = {
                   Frequency: Number(formData?.Frequency) || null,
                   Orgunitid:formData.orgUnit || null,
                   NotificationDate:formData.NotificationDate,
                   NotificationType: formData.NotificationType ||'',
                   IsEnabled: Number(formData.IsEnabled),
                   NotificationTime: formData.NotificationTime || '',
                   NotificationSubject: formData.NotificationSubject ||'',
                   NotificationMessage:formData.NotificationMessage ||'',
                   RedirectScreen: formData.RedirectScreen,
                   Grades: RolesArray ||[],
                   Positions: PositionsArray|| []
               }
               addNotification({ReqBody:ReqBody});
               handleClose();
            }
            if(chechStatusSubmitAndUpdate  === 'Update'){
            const RolesArray = selectedNames.map((item:any)=>(item.id));   

             const ReqBody={
                Frequency:Number(formData?.Frequency),
                Orgunitid:formData.orgUnit,
                NotificationDate:formData.NotificationDate,
                NotificationType: formData.NotificationType,
                IsEnabled: Number(formData.IsEnabled),
                NotificationTime: formData.NotificationTime,
                NotificationSubject: formData.NotificationSubject,
                NotificationMessage:formData.NotificationMessage,
                RedirectScreen: formData.RedirectScreen,
                // Grades: RolesArray || [],
                Grades: RolesArray ,
                // Positions:[]
                Positions:[]
            }

            updateNotification({id:Configuration_ID, ReqBody:ReqBody});
            handleClose();

        };
       }
        const handleInputChange=(key: keyof FormData,value:string | number | number[])=>{
         setformData((prev:any)=>({
              ...prev,
              [key]:value
         }));
        }

       const DataFormModal = [
        {id:0,label:'No'},
        {id:1,label:'Yes'}
       ]

      //  console.log('today:::::::::::::',today);
  return (
  <form onSubmit={handleSubmit}>
  <div className="row mb-12">
  <div className="col-md-4">
       <ReusableDropdown
                    options={
                      (!OrgdataIsLoading&&
                        OrgIsSuccss &&
                        formattedOrgUnitData) ||
                      []
                    }
                    value={formData.orgUnit}
                    onChange={(value: any) => handleInputChange('orgUnit',value)}
                    DropdownHeading="Org Unit"
                  />
        </div>        
        <div className="col-md-4">
        <CustomInput
        required
        label='Notification Type'
         style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      padding: "10px",
                      fontSize: "14px",
                    }}
          value={formData.NotificationType}
          onChange={(e) => handleInputChange('NotificationType',e.target.value)}
         />
        </div>


        <div className="col-md-4 mt-1">
        <label>Is Enabled</label>
        <ReusableDropdown
               value={formData.IsEnabled}
                options={DataFormModal || []} // Ensure correct format
                onChange={(option:any)=>handleInputChange('IsEnabled',option)
                }
            />
        </div>

       </div>
    <div className="row mb-12 mt-2">

        <div className="col-md-4">
                <CustomInput
                    placeholder="Enter notification time"
                    type='time'
                    onChange={(e)=>handleInputChange('NotificationTime',e.target.value)}
                    value={formData.NotificationTime}
                    required={true}
                    label="Notification Time*"
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      padding: "10px",
                      fontSize: "14px",
                    }}
                  />
        </div>
        <div className="col-md-4">
                <CustomInput
                    min={today}
                    type='date'
                    onChange={(e) =>handleInputChange('NotificationDate',e.target.value)}
                    value={formData?.NotificationDate}
                    label="Notification Date"
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      padding: "10px",
                      fontSize: "14px",
                      height:42
                    }}
                  />
        </div>
       <div className="col-md-4">
              <ReusableDropdown
                    options={FrequencyData?.Frequency ||[]}
                    value={formData.Frequency}
                    onChange={(value: any) =>handleInputChange('Frequency',value)}
                    DropdownHeading="Frequency"
                  />
        </div>
      </div>
      <div className="row mb-12 mt-2">
       
        <div className="col-md-4">
                             <CustomInput
                                placeholder="Enter Message"
                                disabled={false}
                                onChange={(e) =>handleInputChange('NotificationMessage',e.target.value)}
                                value={formData.NotificationMessage}
                                required={true}
                                label="Notification Message*"
                                style={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "4px",
                                  padding: "10px",
                                  fontSize: "14px",
                                }}
                              />        
        </div>
      <div className="col-md-4">
              <CustomInput
                    disabled={false}
                    onChange={(e)=>handleInputChange('RedirectScreen',e.target.value) }
                    value={formData.RedirectScreen}
                    label="Redirect Screen*"
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      padding: "10px",
                      fontSize: "14px",
                    }}
                  />      
        </div>
     <div className="col-md-4">
                <CustomInput
                    placeholder="Enter notification subject"
                    type='text'
                    onChange={(e) =>handleInputChange('NotificationSubject',e.target.value)}
                    value={formData.NotificationSubject}
                    required={true}
                    label="Notification Subject"
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      padding: "10px",
                      fontSize: "14px",
                      height:42
                    }}
                  />
        </div>

      </div>

       <div className='row mb-12 mt-2'> 

        <div className="col-md-6">
            <label className="fw-medium">Grade</label>
        <MultiSelectDropdown
            data={!gradeListDataLoading && gradeListDataIsSuccess && gradeListData?.formatedData ||[]}
            selectedNames={(selectedNames) ||[]}
            setSelectedNames={(setSelectedNames) ||[]}
        />   

          </div>

         <div className="col-md-6" style={{position:'relative' ,marginTop:'-7px'}}>
           <PaginatedRouteDropdown
              DropdownHeading='Position'
              isMulti={true}
              // initialSelectedOptions={ chechStatusSubmitAndUpdate  === 'Update' &&(selectPositionEdit) ||[]}
              // initialSelectedOptions={(selectPositionEdit) || []}
              initialSelectedOptions={ chechStatusSubmitAndUpdate  === 'Update' && (selectPositionEdit) || []}
              onChange={(val)=>{
                if (!val) return;
                if (Array.isArray(val)) {
                setSelectPosition((prev:any) => [...prev, ...val]); 
              } else {
                setSelectPosition((prev:any) => [...prev, val]); 
              }
              }}
    
              fetchOptions = {async(page:any,search:  any)=>{
                const res = await getPositionList({
                  page:page,
                  length:10,
                  search: search || ''
                });
                const rowData = await res.formatedData;
                return rowData;
              }} 
           />
       </div>

      </div>

    {/* Buttons */}
    <div className="d-flex justify-content-start mt-4 gap-2">
            <Btn style={{ backgroundColor: "#43B9B2", color: "white" }} type="submit">
           
            {chechStatusSubmitAndUpdate === 'Update' ? 'Update':'Submit'}
            </Btn>
            <Btn
            style={{
                backgroundColor: "#F9FAFC",
                color: "#000",
                border: "1px solid #E0E0E0",
            }}
            type="button"
            onClick={handleClose}>
            Cancel
            </Btn>
        </div>
    </form>
    
    )
 }
 export default NotificationConfigModalContent